import { type JobStatusType } from "@/enum";
import type { IDecimalValueAndUnit, IDigestateJobFormCreate } from "@/interfaces";
import PriceWithUnit from "../PriceWithUnit";

class DigestateJobFormCreate implements IDigestateJobFormCreate {
    status: JobStatusType;
    description: string | null
    farmId: string | null
    collectionSiteInfo: string | null
    pickupADPlantSiteId: string | null
    siloId: string | null
    price: IDecimalValueAndUnit
    scheduleDates: string[] | null 
    assignedEmployeeId: string | null
    assignedVehicleId: string | null
    assignedEquipmentId: string | null
    isRepeatable: boolean
    notes: string | null

    constructor(jobData?: IDigestateJobFormCreate) {
        this.status = jobData?.status as JobStatusType
        this.description = jobData?.description?? null
        this.farmId = jobData?.farmId?? null
        this.collectionSiteInfo = jobData?.collectionSiteInfo?? null
        this.pickupADPlantSiteId = jobData?.pickupADPlantSiteId?? null
        this.siloId = jobData?.siloId?? null
        this.scheduleDates = jobData?.scheduleDates?? null
        this.assignedEmployeeId = jobData?.assignedEmployeeId?? null
        this.assignedVehicleId = jobData?.assignedVehicleId?? null
        this.assignedEquipmentId = jobData?.assignedEquipmentId?? null
        this.isRepeatable = jobData?.isRepeatable?? false
        this.notes = jobData?.notes?? null
        this.price = new PriceWithUnit(jobData?.price)
    }
}

export default DigestateJobFormCreate
